import React, { useState } from 'react';
import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
  Button,
  Input,
  Label,
  makeStyles,
} from '@fluentui/react-components';
import { Add20Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
});

const AddRoutingDialog = ({ isOpen, onClose, onAdd, existingRoutingNames = [] }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [routingName, setRoutingName] = useState('');
  const [error, setError] = useState('');

  const handleAdd = () => {
    const trimmedName = routingName.trim();
    
    // Validation
    if (!trimmedName) {
      setError(t('routingNameRequired') || 'Routing name is required');
      return;
    }
    
    if (existingRoutingNames.includes(trimmedName)) {
      setError(t('routingNameExists') || 'This routing name already exists');
      return;
    }

    // Appeler la fonction de callback
    onAdd(trimmedName);
    
    // Réinitialiser et fermer
    setRoutingName('');
    setError('');
    onClose();
  };

  const handleClose = () => {
    setRoutingName('');
    setError('');
    onClose();
  };

  const handleInputChange = (_, data) => {
    setRoutingName(data.value);
    setError(''); // Clear error when user types
  };

  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => !data.open && handleClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t('addNewRouting') || 'Add New Routing'}</DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <div className={classes.inputContainer}>
              <Label required>{t('routingName') || 'Routing Name'}</Label>
              <Input
                value={routingName}
                onChange={handleInputChange}
                placeholder={t('enterRoutingName') || 'Enter routing name (e.g., ar_message)'}
                autoFocus
              />
              {error && (
                <div style={{ color: '#d13438', fontSize: '12px' }}>
                  {error}
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary" onClick={handleClose}>
                {t('cancel') || 'Cancel'}
              </Button>
            </DialogTrigger>
            <Button appearance="primary" onClick={handleAdd}>
              {t('add') || 'Add'}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default AddRoutingDialog;
